export default function partnerFinancialsReportsListTableColumns(config) {
    let result = {};
    let tableData = [];
    if (!config.data) return null;

    config.data.map((partnerFinancialsReportList) => {
        let row = [];
        const rowId = partnerFinancialsReportList.reportId;
        config.columns.forEach(column => {

            let columnValue = "";
            let displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;

            if (columnDataType === "string") {
                if (column.id === "dateOfExport") {
                    let value = '';
                    if (partnerFinancialsReportList.dateOfExport) {
                        const valueList = partnerFinancialsReportList.dateOfExport.split(' ');
                        value = valueList[0] ? valueList[0].split("/").reverse().join("-") : "";
                        value = value && valueList[1] ? value + ' ' + valueList[1] : '';
                    } else if (partnerFinancialsReportList.dateOfExport) {
                        const valueList = partnerFinancialsReportList.dateOfExport.split(' ');
                        value = valueList[0] ? valueList[0].split("/").reverse().join("-") : "";
                        value = value && valueList[1] ? value + ' ' + valueList[1] : '';
                    }
                    columnValue = value;
                    displayAsIs = true;
                }
                else if (column.id === "download") {
                    columnValue = partnerFinancialsReportList.userId || "";
                    displayAsIs = true;
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: (columnDataType === "icon" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, rowId) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}
